export const incomeDatasets = [
    {
        label: "Sales",
        data: [300, 500, 100, 700, 400, 600, 900, 450],
        backgroundColor: "#378440",
        borderColor: "#378440",
        borderWidth: 1,
    }
]

export const orderDatasets = [
    {
        label: "Return",
        data: [50, 100, 70, 30, 0, 80, 20, 50],
        backgroundColor: "#D82528",
        borderColor: "#D82528",
        borderWidth: 1,
    },
    {
        label: "1 Star",
        data: [300, 500, 0, 700, 400, 600, 0, 450],
        backgroundColor: "#C1D9C4",
        borderColor: "#C1D9C4",
        borderWidth: 1,
    },
    {
        label: "2 Stars",
        data: [150, 250, 30, 0, 150, 300, 0, 200],
        backgroundColor: "#A3C6A7",
        borderColor: "#A3C6A7",
        borderWidth: 1,
    },
    {
        label: "3 Stars",
        data: [300, 500, 0, 700, 400, 0, 900, 450],
        backgroundColor: "#79AD7F",
        borderColor: "#79AD7F",
        borderWidth: 1,
    },
    {
        label: "4 Stars",
        data: [300, 500, 0, 700, 400, 600, 0, 450],
        backgroundColor: "#5F9D66",
        borderColor: "#5F9D66",
        borderWidth: 1,
    },
    {
        label: "5 Stars",
        data: [300, 500, 100, 700, 400, 600, 900, 450],
        backgroundColor: "#378440",
        borderColor: "#378440",
        borderWidth: 1,
    },
]

export const productDatasets = [
    {
        label: "Hay",
        data: [50, 100, 70, 30, 0, 80, 20, 50],
        backgroundColor: "#378440",
        borderColor: "#378440",
        borderWidth: 1,
    },
    {
        label: "Straw",
        data: [120, 50, 70, 80, 90, 10, 30, 45],
        backgroundColor: "#F9A72E",
        borderColor: "#F9A72E",
        borderWidth: 1,
    },
    {
        label: "Hay Seed",
        data: [50, 100, 70, 30, 0, 80, 20, 50],
        backgroundColor: "#0085CC",
        borderColor: "#0085CC",
        borderWidth: 1,
    },
] 

export const visitorDatasets = [
    {
        label: "Hay",
        data: [40, 60, 100, 90, 70, 30, 120, 80],
        backgroundColor: "#378440",
        borderColor: "#378440",
        borderWidth: 1,
    },
]

export const ratingDatasets = [
    {
        label: "Product A",
        data: [100, 200, 50, 300, 200, 250, 400, 150],
        backgroundColor: "#378440",
        borderColor: "#378440",
        borderWidth: 1,
    },
    {
        label: "Product B",
        data: [150, 250, 30, 250, 150, 300, 350, 200],
        backgroundColor: "#0085CC",
        borderColor: "#0085CC",
        borderWidth: 1,
    },
    {
        label: "Product C",
        data: [50, 50, 20, 150, 50, 50, 150, 100],
        backgroundColor: "#FBF973",
        borderColor: "#FBF973",
        borderWidth: 1,
    },
    {
        label: "Product C",
        data: [60, 30, 70, 90, 10, 40, 50, 80],
        backgroundColor: "#F9A72E",
        borderColor: "#F9A72E",
        borderWidth: 1,
    },
]